// extracted by mini-css-extract-plugin
module.exports = {"inputNumberLabel":"FormInputNumber_inputNumberLabel__MXBTr","default":"FormInputNumber_default__1SH4Y","large":"FormInputNumber_large__2AG3-"};